import Modal from "components/ui/modal/modal";
import { FaCogs } from "react-icons/fa";
import ParamImpotSociete from "components/app/AuditComplet/SituationPro/ParamImpotSociete";

function ParamImpotSocietePageModal({ visible = false, onClose }) {

  return (
    <>
      <Modal
        width="45%"
        height="46%"
        title="Paramétrage de l'impôt sur les sociétés"
        icon={<FaCogs />}
        visible={visible}
        onClose={onClose}
      >
        <ParamImpotSociete
          onClose={onClose}
        />
      </Modal>
    </>
  );
}

export default ParamImpotSocietePageModal;
